export class AllocationMismatchError extends Error {
}

export class ExperimentStateError extends Error {
}

export class UserInputError extends Error {
}
